import { useState } from 'react';

const services = [
  {
    id: 'madera-plastica',
    icon: 'ri-recycle-fill',
    color: '#43a047',
    bg: '#f1f8e9',
    title: 'Madera Plástica Posconsumo',
    subtitle: 'Transformación circular',
    description:
      'Recolectamos materiales plásticos posconsumo y los transformamos en madera plástica de alta calidad. Este material ecológico reemplaza la madera natural en construcciones de parques, bancas, cercas, jardines y espacios públicos — durable, resistente y 100% reciclado.',
    highlights: ['Plástico reciclado tipo HDPE y PET', 'Bancas, mesas y estructuras para parques', 'Resistente al agua y la intemperie', 'Cero deforestación'],
    image: 'https://readdy.ai/api/search-image?query=hyperrealistic%20photorealistic%20render%20of%20recycled%20plastic%20wood%20products%20bench%20table%20fence%20pergola%20displayed%20in%20a%20clean%20workshop%20Colombia%20industrial%20transformation%20sustainable%20material%20warm%20lighting%20very%20detailed&width=900&height=600&seq=svc001&orientation=landscape',
  },
  {
    id: 'espacios-publicos',
    icon: 'ri-tree-fill',
    color: '#2e7d32',
    bg: '#e8f5e9',
    title: 'Alamedas, Andenes y Puentes',
    subtitle: 'Mantenimiento de espacios públicos',
    description:
      'Recuperamos y mantenemos alamedas, andenes, puentes peatonales y jardines en los 87 municipios de Santander. Nuestro equipo trabaja con comunidades para restaurar los espacios públicos y devolverles la dignidad y funcionalidad que merecen.',
    highlights: ['Mantenimiento de alamedas arbolizadas', 'Andenes y senderos peatonales', 'Puentes y pasos elevados', 'Jardines y zonas verdes urbanas'],
    image: 'https://readdy.ai/api/search-image?query=hyperrealistic%20photograph%20of%20a%20beautiful%20tree-lined%20pedestrian%20walkway%20alameda%20in%20a%20Colombian%20city%20with%20plastic%20wood%20borders%20benches%20clean%20paved%20path%20lush%20tropical%20trees%20warm%20sunlight%20people%20walking&width=900&height=600&seq=svc002&orientation=landscape',
  },
  {
    id: 'canchas-recreacion',
    icon: 'ri-football-fill',
    color: '#f57f17',
    bg: '#fff8e1',
    title: 'Canchas y Recreación al Aire Libre',
    subtitle: 'Deporte y vida activa',
    description:
      'Construimos y recuperamos canchas deportivas, parques infantiles y zonas de recreación utilizando materiales reciclados, especialmente madera plástica. Espacios dignos para que las comunidades practiquen deporte y compartan al aire libre.',
    highlights: ['Canchas de fútbol, baloncesto y microfútbol', 'Parques infantiles con materiales reciclados', 'Senderos peatonales ecológicos', 'Zonas de ejercicio al aire libre'],
    image: 'https://readdy.ai/api/search-image?query=hyperrealistic%20photo%20of%20a%20community%20sports%20court%20playground%20in%20Colombia%20with%20recycled%20plastic%20wood%20fencing%20goals%20bleachers%20children%20playing%20families%20watching%20green%20grass%20tropical%20trees%20clear%20sky%20vibrant&width=900&height=600&seq=svc003&orientation=landscape',
  },
  {
    id: 'recogida-muebles',
    icon: 'ri-truck-fill',
    color: '#c62828',
    bg: '#ffebee',
    title: 'Recogida de Muebles y Llantas',
    subtitle: 'Residuos voluminosos',
    description:
      'Prestamos servicio de recolección de muebles de todo tipo — sofás, colchones, sillas, armarios — así como llantas y residuos voluminosos que contaminan calles, ríos y zonas verdes. Los transformamos o disponemos de forma responsable.',
    highlights: ['Sofás, colchones, armarios, mesas', 'Llantas y neumáticos usados', 'Electrodomésticos y chatarra', 'Servicio gratuito para comunidades'],
    image: 'https://readdy.ai/api/search-image?query=hyperrealistic%20photograph%20of%20waste%20collection%20truck%20collecting%20old%20furniture%20mattresses%20tires%20in%20a%20Colombian%20neighborhood%20community%20recycling%20collection%20workers%20in%20uniform%20clean%20urban%20environment%20warm%20light&width=900&height=600&seq=svc004&orientation=landscape',
  },
  {
    id: 'zonas-verdes',
    icon: 'ri-plant-fill',
    color: '#00695c',
    bg: '#e0f2f1',
    title: 'Recuperación de Zonas Verdes',
    subtitle: 'Naturaleza restaurada',
    description:
      'Recuperamos zonas verdes, parques deteriorados y espacios públicos abandonados. Sembramos árboles nativos, instalamos jardines comunitarios y transformamos zonas contaminadas en pulmones verdes para las ciudades de Santander.',
    highlights: ['Siembra de árboles nativos', 'Jardines comunitarios participativos', 'Parques recuperados con materiales reciclados', 'Educación ambiental en sitio'],
    image: 'https://readdy.ai/api/search-image?query=hyperrealistic%20aerial%20photograph%20of%20a%20restored%20urban%20green%20zone%20park%20in%20Bucaramanga%20Colombia%20with%20native%20trees%20community%20garden%20plastic%20wood%20benches%20paths%20clean%20environment%20lush%20vegetation%20sunlight%20golden%20hour%20vibrant%20colors&width=900&height=600&seq=svc005&orientation=landscape',
  },
];

export default function ServicesSection() {
  const [active, setActive] = useState(0);

  const current = services[active];

  return (
    <section id="servicios" className="w-full bg-white py-24 px-6 md:px-14">
      {/* Header */}
      <div className="text-center mb-14">
        <span
          className="inline-block text-[#43a047] text-[10px] tracking-[0.45em] uppercase font-semibold mb-3"
          style={{ fontFamily: "'Montserrat', sans-serif" }}
        >
          Soluciones de Ingeniería · Lo que hacemos
        </span>
        <h2
          className="text-[#1b5e20] font-bold leading-tight mb-4"
          style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: 'clamp(2rem, 4vw, 3.2rem)',
          }}
        >
          Transformamos. No solo reciclamos.
        </h2>
        <p
          className="text-[#4a5568] text-base max-w-2xl mx-auto leading-relaxed"
          style={{ fontFamily: "'Montserrat', sans-serif" }}
        >
          FRAIS no es una recicladora — es una transformadora de materiales denominados inservibles. 
          Cada residuo tiene un destino: el espacio público, la industria o la construcción de Santander.
        </p>
      </div>

      {/* Service Tabs */}
      <div className="flex flex-wrap justify-center gap-3 mb-10">
        {services.map((svc, idx) => (
          <button
            key={svc.id}
            onClick={() => setActive(idx)}
            className={`flex items-center gap-2 px-5 py-2.5 rounded-full text-xs font-bold tracking-wider uppercase transition-all duration-300 cursor-pointer whitespace-nowrap ${
              active === idx
                ? 'text-white scale-105'
                : 'text-gray-500 hover:text-gray-700'
            }`}
            style={{
              fontFamily: "'Montserrat', sans-serif",
              backgroundColor: active === idx ? svc.color : '#f5f5f5',
            }}
          >
            <i className={svc.icon}></i>
            <span className="hidden sm:inline">{svc.title.split(' ').slice(0, 2).join(' ')}</span>
          </button>
        ))}
      </div>

      {/* Active Service Detail */}
      <div
        key={current.id}
        className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 rounded-2xl overflow-hidden"
        style={{
          backgroundColor: '#fff',
          border: `1px solid ${current.color}25`,
          animation: 'fadeInService 0.4s ease',
        }}
      >
        {/* Image */}
        <div className="relative overflow-hidden" style={{ minHeight: '360px' }}>
          <img
            src={current.image}
            alt={current.title}
            className="w-full h-full object-cover object-center"
            style={{ minHeight: '360px' }}
          />
          <div className="absolute inset-0 bg-gradient-to-r from-transparent to-transparent"></div>
        </div>

        {/* Info */}
        <div className="flex flex-col justify-center p-8 md:p-10">
          <div
            className="inline-flex items-center gap-3 mb-4"
          >
            <div
              className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0"
              style={{ backgroundColor: current.color }}
            >
              <i className={`${current.icon} text-white text-xl`}></i>
            </div>
            <div>
              <p
                className="text-xs font-semibold tracking-widest uppercase mb-0.5"
                style={{ color: current.color, fontFamily: "'Montserrat', sans-serif" }}
              >
                {current.subtitle}
              </p>
              <h3
                className="text-[#1b5e20] font-bold text-xl leading-tight"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                {current.title}
              </h3>
            </div>
          </div>

          <p
            className="text-[#4a5568] text-sm leading-relaxed mb-6"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            {current.description}
          </p>

          {/* Highlights */}
          <ul className="space-y-2.5 mb-7">
            {current.highlights.map((item) => (
              <li key={item} className="flex items-start gap-3">
                <div
                  className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5"
                  style={{ backgroundColor: current.color + '22' }}
                >
                  <i className="ri-check-line text-xs" style={{ color: current.color }}></i>
                </div>
                <span
                  className="text-[#374151] text-sm"
                  style={{ fontFamily: "'Montserrat', sans-serif" }}
                >
                  {item}
                </span>
              </li>
            ))}
          </ul>

          <a
            href="/contacto"
            className="inline-flex items-center gap-2 text-xs font-bold tracking-widest uppercase px-6 py-3 rounded-full text-white transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap w-fit"
            style={{ backgroundColor: current.color, fontFamily: "'Montserrat', sans-serif" }}
          >
            Solicitar este servicio
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>

      {/* Navigation dots */}
      <div className="flex justify-center gap-2 mt-6">
        {services.map((_, idx) => (
          <button
            key={idx}
            onClick={() => setActive(idx)}
            className={`h-1.5 rounded-full transition-all duration-300 cursor-pointer ${
              active === idx ? 'w-8' : 'w-3 bg-gray-300'
            }`}
            style={{ backgroundColor: active === idx ? services[idx].color : undefined }}
          />
        ))}
      </div>

      <style>{`
        @keyframes fadeInService {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </section>
  );
}
